import { useEffect, useState } from "react";
import { Card, Form, Button } from "react-bootstrap";
import { getOrg, getUsccbOrg, putDiocesis } from "../../controllers/org";
import Loading from "../loading/Loading";
import { useAuth } from "../auth/AuthProvider";
import { Typeahead } from 'react-bootstrap-typeahead';
import { useToast } from "../toast/ToastContext";

function CrearDiocesis({ org, onSuccess, defaultRegion }) {
  const [usccbDiocesis, setUsccbDiocesis] = useState(null);
  const [region, setRegion] = useState(defaultRegion?.region_id);
  const [isLoading, setIsLoading] = useState(false);
  const { token } = useAuth();
  const showToast = useToast();
  const [regiones, setRegiones] = useState(org?.regiones);
  const [usccbOrg, setUsccbOrg] = useState();

  // const options = [
  //   { id: 'opt1', label: 'Option 1', value: 'value1' },
  //   { id: 'opt2', label: 'Option 2', value: 'value2' },
  //   { id: 'opt3', label: 'Option 3', value: 'value3' },
  // ];

  useEffect(() => {
    if (!regiones) {
      loadOrg();
    }
    loadUsccbOrg();
  }, []);

  useEffect(() => {
    if (org) {
      setRegiones(org.regiones);
    }
  }, [org]);

  async function loadOrg(){
    let o = await getOrg();
    setRegiones(o.regiones);
  }
  async function loadUsccbOrg(){
    let o = await getUsccbOrg();
    setUsccbOrg(o);
  }

  async function submit(e) {
    e.preventDefault();
    setIsLoading(true);
    try {
      await putDiocesis(`${usccbDiocesis[0].label}, ${usccbDiocesis[0].state_code}`, region, usccbDiocesis[0].usccb_diocese_id, token);
      showToast({
        message: `Se creó la diócesis ${usccbDiocesis[0].label} con éxito.`,
        bg: 'success',
        autohide: true,
        delay: 7000,
        title: 'Diócesis creada'
      });
      setUsccbDiocesis();
      setRegion();
      if (onSuccess && typeof onSuccess === 'function') {
        onSuccess();
      }
    }
    catch (e) {
      showToast({
        message: `Error al crear diócesis. ${e.message || ''}`,
        bg: 'danger',
        autohide: true,
        delay: 7000,
        title: 'Error al crear diócesis'
      });
    }
    setIsLoading(false);
  }

  function generateRegionOptions(){
    return regiones.map((it, idx) => {
      return <option value={it.region_id} key={'crear-diocesis-region-option-' + it.region_id}>{it.label}</option>;
    });
  }

  if (isLoading) {
    return <Card>
      <Card.Header>Crear Diócesis</Card.Header>
      <Card.Body><Loading text="Creando diócesis..." /></Card.Body>
    </Card>
  }
  if (!usccbOrg) {
    return <Card>
      <Card.Header>Crear Diócesis</Card.Header>
      <Card.Body><Loading text="Cargando..." /></Card.Body>
    </Card>
  }

  return <Card className="crear-org crear-diocesis">
    <Card.Header>Crear Diócesis en FAMA</Card.Header>
    <Card.Body>
      <Form>
        <Form.Group className="mb-3">
          <Form.Label>Diócesis de USCCB</Form.Label>
          <Typeahead
            id="async-region"
            labelKey="label"
            onChange={(selected) => {
              console.log(selected);
              setUsccbDiocesis(selected);
            }}
            options={usccbOrg.usccbDiocesis}
            placeholder="Selecciona la diócesis"
            renderMenuItemChildren={(option) => (
                <span>{option.label}, {option.state_code}</span>
            )}
            selected={usccbDiocesis}
          />
        </Form.Group>
        { !defaultRegion && <Form.Group className="mb-3">
          <Form.Label>Región</Form.Label>
          <Form.Select onChange={e => setRegion(parseInt(e.target.value))} defaultValue={region}>
            <option value={null}>-- Selecciona una región --</option>
            {generateRegionOptions()}
          </Form.Select>
        </Form.Group>}
        {!!usccbDiocesis && !!region && <Form.Group className="mb-3 submit-buttons-wrapper">
          <Button key='submit-btn-new-diocesis' type='submit' variant='primary' onClick={submit}>Guardar diócesis</Button>
        </Form.Group>}
      </Form>
    </Card.Body>
  </Card>
}

export default CrearDiocesis;
